export enum PrivilegesUsers {
    Select = 'select',
    Disp = 'disp',
    Edit = 'edit',
    Oper = 'oper',
}
